(() => {
  const source = document.currentScript?.dataset.flickitySrc;
  let library;
  const initialized = new WeakSet();
  const getLibrary = () => {
    if (window.Flickity) return Promise.resolve(window.Flickity);
    if (!library) {
      library = new Promise((resolve, reject) => {
        if (!source) { reject(new Error('Missing carousel asset')); return; }
        const script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.addEventListener('load', () => resolve(window.Flickity), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.append(script);
      }).catch(error => { library = null; throw error; });
    }
    return library;
  };
  const initialize = element => {
    if (initialized.has(element)) return;
    initialized.add(element);
    getLibrary().then(Flickity => {
      if (!element.isConnected) return;
      const reviews = element.matches('.TestimonialFooter__Reviews');
      new Flickity(element, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: !reviews,
        pageDots: true,
        adaptiveHeight: true,
        ...(reviews ? { watchCSS: true } : { initialIndex: 1 })
      });
    }).catch(() => { initialized.delete(element); });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      initialize(entry.target);
    });
  }, { rootMargin: '300px' }) : null;
  const scan = root => {
    root.querySelectorAll('.TestimonialFooter__Reviews,.product-gallery__custom-carousel').forEach(element => {
      if (observer) observer.observe(element);
      else initialize(element);
    });
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('.size-guide-popup__link')) {
      event.stopPropagation();
      document.querySelectorAll('.size-guide-image').forEach(element => element.classList.add('open'));
    } else if (target.closest('.size-guide__close') || !target.closest('.size-guide-image.open .size-guide__table')) {
      document.querySelectorAll('.size-guide-image.open').forEach(element => element.classList.remove('open'));
    }
  });
})();
